/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Cognito Challenge Name
 * @export
 */
export const CognitoChallengeNameSchema = {
    AdminNoSrpAuth: 'ADMIN_NO_SRP_AUTH',
    CustomChallenge: 'CUSTOM_CHALLENGE',
    DevicePasswordVerifier: 'DEVICE_PASSWORD_VERIFIER',
    DeviceSrpAuth: 'DEVICE_SRP_AUTH',
    MfaSetup: 'MFA_SETUP',
    NewPasswordRequired: 'NEW_PASSWORD_REQUIRED',
    PasswordVerifier: 'PASSWORD_VERIFIER',
    SelectMfaType: 'SELECT_MFA_TYPE',
    SmsMfa: 'SMS_MFA',
    SoftwareTokenMfa: 'SOFTWARE_TOKEN_MFA'
} as const;
export type CognitoChallengeNameSchema = typeof CognitoChallengeNameSchema[keyof typeof CognitoChallengeNameSchema];


export function instanceOfCognitoChallengeNameSchema(value: any): boolean {
    for (const key in CognitoChallengeNameSchema) {
        if (Object.prototype.hasOwnProperty.call(CognitoChallengeNameSchema, key)) {
            if (CognitoChallengeNameSchema[key as keyof typeof CognitoChallengeNameSchema] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CognitoChallengeNameSchemaFromJSON(json: any): CognitoChallengeNameSchema {
    return CognitoChallengeNameSchemaFromJSONTyped(json, false);
}

export function CognitoChallengeNameSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoChallengeNameSchema {
    return json as CognitoChallengeNameSchema;
}

export function CognitoChallengeNameSchemaToJSON(value?: CognitoChallengeNameSchema | null): any {
    return value as any;
}

